import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

const PDF_URL = "/menu/carta-es.pdf";

const Carta = () => (
  <section id="carta" data-testid="carta-section" className="py-16 md:py-24 bg-brand-charcoal text-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <Reveal>
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-pink">La carta</p>
        <h2 className="mt-3 font-display font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl">
          DESCUBRE NUESTRA <span className="text-brand-pink">CARTA</span>
        </h2>
        <p className="mt-4 text-base md:text-lg text-white/70 leading-relaxed max-w-xl">
          Los CROC, Sweet Croc, La Crocca, helado y bebidas: toda la carta en un
          vistazo, lista para abrir también desde el móvil.
        </p>
        <div className="mt-8">
          <a
            data-testid="carta-ver-button"
            href={PDF_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-brand-pink text-white font-semibold uppercase tracking-wide rounded-full px-8 py-3.5 hover:bg-brand-pink/90 hover:scale-105 transition-transform"
          >
            Ver la carta
            <ArrowRight className="w-4 h-4" aria-hidden="true" />
          </a>
        </div>
        <a
          data-testid="carta-alergenos-link"
          href="/alergenos"
          className="mt-10 inline-flex items-center gap-2 text-sm text-white/60 hover:text-brand-pink transition-colors"
        >
          <span className="font-semibold uppercase tracking-wide">¿Alergias o intolerancias?</span>
          <span className="underline underline-offset-2">
            Consulta nuestra información sobre alérgenos
          </span>
          <ArrowRight className="w-4 h-4" aria-hidden="true" />
        </a>
      </Reveal>
      <Reveal delay={0.15} className="flex justify-center lg:justify-end">
        <a
          data-testid="carta-pdf-preview"
          href={PDF_URL}
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Abrir la carta en PDF (se abre en una pestaña nueva)"
          className="block w-full max-w-md md:max-w-lg"
        >
          <img
            src="/menu/carta-preview.webp"
            alt="Vista previa de la carta de CROC LAB"
            className="w-full h-auto rounded-3xl border-4 border-white/10 shadow-2xl rotate-2 hover:rotate-0 hover:scale-[1.02] transition-transform duration-300"
            loading="lazy"
          />
        </a>
      </Reveal>
    </div>
  </section>
);

export default Carta;
